'use strict';

require('core-js/stable');
require('regenerator-runtime/runtime');
require('whatwg-fetch');
